import { BusinessModel } from '@/http/models/business'

import { useEffect, useState } from 'react'

import { BusinessResponses } from '@/types'

export const useBusinessProfile = () => {
  const [profile, setProfile] = useState<BusinessResponses.BusinessProfile['result'] | null>(null)
  const [loading, setLoading] = useState(true)

  const fetchProfile = async () => {
    try {
      const response = await BusinessModel.getBusinessProfile()
      if (response.success && response.data) {
        setProfile(response.data.result)
      }
    } catch (e) {
      console.error('Failed to fetch business profile', e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchProfile()
  }, [])

  return { profile, loading, refresh: fetchProfile }
}
